<div data-testid="notifications-group">
  @for (notification of notifications(); track notification) {
    @if (notification) {
      @if (notification.context === 'none') {
        <ng-container *ngComponentOutlet="notification.message; inputs: notification.messageInputs" />
      } @else {
        <nx-message
          [context]="notification.context"
          class="my-3.5"
          [attr.data-testid]="`notifications-group-message-${$index}`"
        >
          <ng-container *ngComponentOutlet="notification.message; inputs: notification.messageInputs" />
        </nx-message>
      }
    }
  }
</div>
